import ValidatePage from "@/router/modules/methods/validate";

export default {
    path: '/auth/code',
    name: 'AuthCode',
    component: () => import('@/views/auth/auth_code.vue'),
    meta: {
        title: 'Авторизация',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await ValidatePage(next)
    }
}